import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import AddProduct from './pages/AddProduct';
import Orders from './pages/Orders';
import OrderDetail from './pages/OrderDetail';
import AdminNavbar from './components/AdminNavbar';

function PrivateRoute({ children }) {
  const { admin } = useAuth();
  return admin ? (
    <>
      <AdminNavbar />
      <div className="p-6 max-w-7xl mx-auto">{children}</div>
    </>
  ) : (
    <Navigate to="/login" />
  );
}

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/products" element={<PrivateRoute><Products /></PrivateRoute>} />
        <Route path="/products/add" element={<PrivateRoute><AddProduct /></PrivateRoute>} />
        <Route path="/products/edit/:id" element={<PrivateRoute><AddProduct /></PrivateRoute>} />
        <Route path="/orders" element={<PrivateRoute><Orders /></PrivateRoute>} />
        <Route path="/orders/:id" element={<PrivateRoute><OrderDetail /></PrivateRoute>} />
      </Routes>
    </AuthProvider>
  );
}

export default App;